<template src="@/templates/bookings/bookingListItem.html"></template>

<script>
import { mapActions, mapGetters } from "vuex";
import fileView from "@/components/file/FileView";

export default {
  name: "BookingListItem",
  props: [
    "bookingModel",
    "booking_view",
    "parentComp",
    "topJob",
    "searchDate",
    "type",
  ],
  components: { fileView },
  data() {
    return {
      bookingAvailableOnsiteProps: [
        "location_name_title",
        "booking_type",
        "language",
        "service_date_formatted",
        "start",
        "end",
        "location_suburb",
      ],
      bookingAvailableTelephoneProps: [
        "location_name_title",
        "booking_type",
        "language",
        "service_date_formatted",
        "interpreter_local",
        "job_local",
        "location_suburb",
      ],
      bookingAvailableVideoProps: [
        "location_name_title",
        "booking_type",
        "language",
        "service_date_formatted",
        "interpreter_local",
        "job_local",
        "location_suburb",
      ],
      confirmedProps: [
        "client_name",
        "location_name",
        "ref_num",
        "language",
        "service_date_formatted",
        "start",
        "end",
        "location_address_1",
        "location_address_2",
        "location_postcode",
        "calds",
      ],
      searchConfirmedProps: [
        "client_name",
        "location_name",
        "ref_num",
        "language",
        "service_date_formatted",
        "start",
        "end",
        "location_address_1",
        "location_address_2",
        "location_postcode",
        "calds",
      ],
      searchConfirmedByDayProps: [
        "client_name",
        "location_name",
        "ref_num",
        "language",
        "service_date_formatted",
        "start",
        "end",
        "location_address_1",
        "location_address_2",
        "location_postcode",
        "calds",
      ],
      sdPendingProps: [
        "client_name",
        "ref_num",
        "language",
        "service_date_formatted",
        "start",
        "end",
      ],
      sdUploadedProps: [
        "client_name",
        "ref_num",
        "language",
        "service_date_formatted",
        "start",
        "end",
      ],
      viewFileViewUploadedComp: false,
      isThis: "SDUploaded",
      parentCompToReturn: "",
      messageState: "",
      messageClass: "",
    };
  },
  computed: {
    ...mapGetters(["getClockOnOffMessage"]),
    isCancelled() {
      if (this.bookingModel.cancellation == "Yes") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    Event.$on("hideFileViewComp", (isThis) => {
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          thisComponent.viewFileViewUploadedComp = false;
        }, 50);
      }
    });

    Event.$on("getClockOnOffStatus", () => {
      console.log("getClockOnOffStatus");
      console.log(this.getClockOnOffMessage);
      for (const item of this.getClockOnOffMessage) {
        if (this.bookingModel.ref_num == item.refNum) {
          this.messageState = item.message;
          this.messageClass = item.classColor;
        }
      }
    });
  },
  beforeDestroy() {
    console.log("offgetClockOnOffStatusBookingListItem");
    Event.$off("getClockOnOffStatus");
    this.updateScrollStatus(false);
  },
  methods: {
    ...mapActions([
      "updateReturnToComp",
      "updateImageFor",
      "updateSearchDate",
      "updateScrollStatus",
    ]),
    // moment: function () {
    //     return moment();
    // },
    bookingType(booking_type) {
      let value = "";
      switch (booking_type) {
        case "Inter":
          value = "Onsite Interpreting";
          break;
        case "Ph Int":
          value = "Phone Interpreting";
          break;
        case "Video":
          value = "Video Interpreting";
          break;
        case "Trans":
          value = "Translation";
          break;
        default:
          break;
      }
      return value;
    },
    buttonAction() {
      switch (this.booking_view) {
        case "sd_uploaded":
          this.viewSDForm();
          break;
        default: {
          if (this.booking_view == "search_confirmed_by_day") {
            this.parentCompToReturn = "SearchConfirmedByDay";
          } else if (this.booking_view == "search_confirmed") {
            this.parentCompToReturn = "SearchConfirmed";
          } else {
            this.parentCompToReturn = this.parentComp;
          }

          this.gotoBookingDetail(this.bookingModel.ref_num);
          break;
        }
      }
    },
    gotoBookingDetail(ref_num) {
      this.updateImageFor("jobSlips");
      this.updateReturnToComp(this.parentCompToReturn);

      let route = "/bookingdetail/" + ref_num + "/" + this.parentCompToReturn;
      if (this.booking_view == "sd_pending") {
        route =
          "/bookingdetail/" +
          ref_num +
          "/" +
          this.parentCompToReturn +
          "?type=" +
          this.type +
          "&booking_view=" +
          this.booking_view;
      }

      this.$router.push({
        path: route,
        query: {
          startDate: this.searchDate.startDate,
          endDate: this.searchDate.endDate,
        },
      });
    },
    isVisible(property) {
      switch (this.booking_view) {
        case "booking_available_onsite":
          if (
            this.bookingAvailableOnsiteProps.find(
              (element) => element == property
            )
          )
            return true;
          break;
        case "booking_available_telephone":
          if (
            this.bookingAvailableTelephoneProps.find(
              (element) => element == property
            )
          )
            return true;
          break;
        case "booking_available_video":
          if (
            this.bookingAvailableVideoProps.find(
              (element) => element == property
            )
          )
            return true;
          break;
        case "confirmed":
          if (this.confirmedProps.find((element) => element == property))
            return true;
          break;
        case "confirmed_today":
          if (this.confirmedProps.find((element) => element == property))
            return true;
          break;
        case "search_confirmed":
          if (this.searchConfirmedProps.find((element) => element == property))
            return true;
          break;
        case "search_confirmed_by_day":
          if (
            this.searchConfirmedByDayProps.find(
              (element) => element == property
            )
          )
            return true;
          break;
        case "sd_pending":
          if (this.sdPendingProps.find((element) => element == property))
            return true;
          break;
        case "sd_uploaded":
          if (this.sdUploadedProps.find((element) => element == property))
            return true;
          break;
        default:
          break;
      }
    },
    viewSDForm() {
      this.viewFileViewUploadedComp = true;
    },
  },
};
</script>

<style scoped>
#ulBookingAvailableItem {
  list-style: none;
}

#ulBookingAvailableItem > li {
  text-align: left;
  font-size: 0.8rem;
}
</style>
